import { forwardRef, memo } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

export const NewDocument = memo(
  forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 248 143"
        data-fill-none
      >
        <rect
          width="248"
          height="143"
          rx="4"
          fill="#ECF2FF"
        />
        <path
          d="M160.322 100.061H121.745H99.7H88.6778C85.7385 100.061 83.1667 97.7799 83.1667 95.1722V46.2834C83.1667 43.676 85.7385 41.3945 88.6778 41.3945H160.322C163.262 41.3945 165.833 43.676 165.833 46.2834V95.1722C165.833 97.7799 163.262 100.061 160.322 100.061Z"
          fill="white"
          stroke="#0C5CEF"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          x="91.1667"
          y="64.5273"
          width="34.6667"
          height="2"
          rx="1"
          fill="#0C5CEF"
        />
        <rect
          x="91.1667"
          y="71.8613"
          width="64"
          height="2"
          rx="1"
          fill="#0C5CEF"
        />
        <rect
          x="91.1667"
          y="79.1934"
          width="50.6667"
          height="2"
          rx="1"
          fill="#0C5CEF"
        />
        <rect
          x="149.639"
          y="25.0039"
          width="32.1481"
          height="32.1481"
          rx="16.0741"
          fill="#0C5CEF"
        />
        <path
          d="M165.713 33.041V49.1151"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M157.676 41.0781H173.75"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </SvgIcon>
    );
  })
);
NewDocument.displayName = 'NewDocument';
